import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameManager } from "../../GameManager";
import { HUD } from "./hud/HUD";
import { GUI } from "./gui/GUI";
import { BoardContainer } from "./BoardContainer";
import { GameConstants } from "../../GameConstants";
import { BoardManager } from "./BoardManger";
import { GameOverLayer } from "./game-over-layer/GameOverLayer";
import { BackgroundContainer } from "./BackgroundContainer";
import { MessagesLayer } from "./MessagesLayer";
import { PauseLayer } from "./PauseLayer";
import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";

export class BoardScene extends Phaser.Scene {

    public static currentInstance: BoardScene;
    public static readonly DELAY_GAME_OVER = 2000;

    public hud: HUD;
    public gameOverLayer: GameOverLayer;

    private gui: GUI;
    private boardContainer: BoardContainer;
    private backgroundContainer: BackgroundContainer;
    private messagesLayer: MessagesLayer;
    private pauseLayer: PauseLayer;

    constructor() {

        super("BoardScene");
        
        BoardScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.messagesLayer = null;
        this.pauseLayer = null;

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0x000000);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        if (!this.anims.exists("foil_fx")) {
            this.anims.create(
                {key: "foil_fx", 
                frames: this.anims.generateFrameNames("texture_atlas_2", {prefix: "foil_fx_", start: 1, end: 20, zeroPad: 2, suffix: ""}), 
                frameRate: 20, 
                repeat: -1
            });
        }

        if (!this.anims.exists("slash_fx")) {
            this.anims.create(
                {key: "slash_fx", 
                frames: this.anims.generateFrameNames("texture_atlas_1", {prefix: "slash_fx_", start: 1, end: 21, zeroPad: 2, suffix: ""}), 
                frameRate: 32,
                hideOnComplete: true
            });
        }

        if (!this.anims.exists("chest_hover_fx")) {
            this.anims.create(
                {key: "chest_hover_fx", 
                frames: this.anims.generateFrameNames("texture_atlas_2", {prefix: "fx_hover_chest_", start: 1, end: 24, zeroPad: 2, suffix: ""}), 
                frameRate: 24,
                repeat: -1
            });
        }

        if (!this.anims.exists("flame_fx")) {
            this.anims.create(
                {key: "flame_fx", 
                frames: this.anims.generateFrameNames("texture_atlas_3", {prefix: "spell_", start: 0, end: 21, zeroPad: 2, suffix: ""}), 
                frameRate: 24,
                hideOnComplete: true
            });
        }

        this.backgroundContainer = new BackgroundContainer(this);
        this.add.existing(this.backgroundContainer);

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        BoardManager.init();

        this.cameras.main.fadeIn(1250, 0, 0, 0);
    }

    public update(): void {

        BoardManager.update();

        this.gui.update();
        this.hud.update();
    }

    public startGame(): void {

        this.backgroundContainer.startGame();
        this.boardContainer.startGame();
        this.gui.startGame();
        this.hud.startGame();

        AudioManager.stopSound("splash_loop");
        AudioManager.stopSound("victory_loop");
        AudioManager.stopSound("gameover_loop");
        AudioManager.stopSound("soundtrack_loop");

        AudioManager.playSound("soundtrack_loop", true, 2);
    }

    public pauseGame(): void {

        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);
    }

    public resumeGame(): void {

        this.pauseLayer.destroy();
        this.pauseLayer = null;

        this.gui.resumeGame();
    }

    public onActionProcessed(): void {

        this.boardContainer.onActionProcessed();
        this.backgroundContainer.onActionProcessed();  
        this.hud.onActionProcessed();
    }

    public onGameOver(): void {

        this.boardContainer.onGameOver();
 
        this.backgroundContainer.onGameOver();
        this.hud.onGameOver();
        this.gui.onGameOver();

        const delay = GameVars.victory ? BoardScene.DELAY_GAME_OVER : 0;

        this.time.delayedCall(delay, () => {

            this.gameOverLayer = new GameOverLayer(this);
            this.add.existing(this.gameOverLayer);

             AudioManager.stopSound("soundtrack_loop");

            if (GameVars.victory) {
                AudioManager.playSound("successful_run");
                AudioManager.playSound("victory_loop", true);
            } else {
                AudioManager.playSound("gameover_loop", true);
            }

        }, [], this);
    }

    public showMessageLayer(msg: string): void {

        if (this.messagesLayer) {
            return;
        }

        this.messagesLayer = new MessagesLayer(this, msg);
        this.add.existing(this.messagesLayer);
    }

    public hideMessageLayer(): void {

        if (this.messagesLayer === null) {
            return;
        }
        
        this.messagesLayer.destroy();
        this.messagesLayer = null;
    }

    public onCardDealt(): void {

        this.hud.onCardDealt();
    }
}
